module.exports = __webpack_public_path__ + "assets/loop-edit-grid.af634a1f.svg";